import React, { useEffect, cloneElement } from "react";
import TopNav from "~/common/components/TopNav";
import SideBar from "~/common/components/SideBar";
import Footer from "~/common/components/Footer";
// import TopButton from "~/common/components/TopButton";
import PropsProvider from "~/common/components/PropsProvider";
import { useGlobalStore } from "~/store";
import { setCurrentMenu } from "~/store/sidebar/actions";
import { useNavigate } from "react-router";
// import ChannelBotButton from "~/common/components/ChannelBotButton";
import Business from "~/pages/DashboardPage/Business";

const NavbarAndSidebarLayout = ({ menu = [], type = "", children, menuName, buttonList }) => {
	const [mainMenuId, subMenuId] = menu;

	const pageClassName = menuName
		? menuName
		: subMenuId
			? [mainMenuId, subMenuId].join("-")
			: mainMenuId;

	const [
		{
			user: { info },
			sidebar: { authMap },
		},
		dispatch,
	] = useGlobalStore();
	const navigate = useNavigate();

	const buttons = () => {
		return buttonList.map((child, index) => {
			return cloneElement(child, { key: `${type}_${index}` });
		});
	};

	const shouldMount =
		mainMenuId === "dashboard" || authMap[type]?.[mainMenuId]?.[subMenuId] !== "none";

	useEffect(() => {
		if (shouldMount) {

			dispatch(
				setCurrentMenu({
					main: mainMenuId,
					sub: subMenuId,
					type: type,
				})
			);
		} else {
			navigate("/dashboard");
		}
	}, []);

	const failBannerHeight = info.userRequirements === false ? "60px" : "0px";

	return (
		<div className="l__dashboard">
			<Business />
			<TopNav />
			<div className="l__mainContainer">
				<SideBar currentMenu={menu} currentType={type} />
				<main
					className="l__main"
					id="l__main"
					style={{ maxHeight: `calc(100vh - 100px - ${failBannerHeight})` }}
				>
					<div className={`l__content p__${pageClassName}`}>
						{shouldMount && (
							<PropsProvider props={{ menu: menu, type: type }}>
								{children}
							</PropsProvider>
						)}
						<div className="pageHeader-btn-group">{buttonList && buttons()}</div>
					</div>
					<Footer />
					{/*<ChannelBotButton id={"user"} />*/}
					{/*<TopButton scrollTarget={"l__main"} />*/}
				</main>
			</div>
		</div>
	);
};

export default NavbarAndSidebarLayout;
